module.exports = __WEBPACK_EXTERNAL_MODULE_294__;


//////////////////
// WEBPACK FOOTER
// external "weaPortal"
// module id = 294
// module chunks = 67